/*js for reviews page*/
$(document).ready(function () {
    /*review nav dropdown*/
    $('.review__navBtn').on('click', function (e) {
        e.preventDefault();

        $(this).siblings('.nav__list').toggleClass('active');
    });

    /*show more products to rate*/
    $('.products__showMore').on('click', function (e) {
        e.preventDefault();

        $('.reviewsPage__products .products__list .productItem').removeClass('mobile-hide');
    });
});
